import request, { get, put } from "./httpService";

const TASK_ENDPOINT = '/task';

const create = (data) => {
    return request({
        method: "POST",
        url: `${TASK_ENDPOINT}/new`,
        data: data,
    });
};

const getById = (id) => {
    return get({
        url: `${TASK_ENDPOINT}/${id}`,
    });
};

const search = (params, config = {}) => {
    return request({
        method: 'GET',
        url: `${TASK_ENDPOINT}/search`,
        params: params,
        ...config,
        suppressErrorToast: config.suppressErrorToast || false
    });
};

// const getWithLimit = (from, to, filters, sortBy, customerId, signal) => {
//     return request({
//         method: "GET",
//         url: `${PRESCRIPTION_ENDPOINT}/withlimit/${from}/${to}`,
//         params: { filters: filters, sortBy: sortBy, customerId: customerId },
//         signal: signal
//     });
// };

const updateStatus = (taskId, status) => {
    return put({
        url: `${TASK_ENDPOINT}/${taskId}/status`,
        data: { status }
    });
};

const update = (taskId, data) => {
    return put({
        url: `${TASK_ENDPOINT}/${taskId}`,
        data: data
    });
};

const remove = (taskId) => {
    return request({
        method: "DELETE",
        url: `${TASK_ENDPOINT}/${taskId}`,
    });
};

const getByEntity = (entityType, entityId) => {
    return get({
        url: `${TASK_ENDPOINT}/entity/${entityType}/${entityId}`,
    });
};

const countOverdue = () => {
    return get({
        url: `${TASK_ENDPOINT}/count/overdue`,
    });
};

const countPending = () => {
    return get({
        url: `${TASK_ENDPOINT}/count/pending`,
    });
};

export const TaskService = {
    create,
    getById,
    search,
    updateStatus,
    update,
    remove,
    getByEntity,
    countOverdue,
    countPending,
};
